import type { HomePlanCategory } from "api-types/homePlans/homePlanTypes";
import cx from "ui/cx";
import IconLocked from "ui/icons/IconLocked";
import IconPerson from "ui/icons/IconPerson";
import type { SvgIconProps } from "ui/icons/SVGIcon";
import SvgIcon from "ui/icons/SVGIcon";
import styles from "./IconHomePlanCategory.module.scss";

interface IconHomePlanCategoryProps extends SvgIconProps {
  category: HomePlanCategory;
}

export default function IconHomePlanCategory({
  category = "contract",
  className,
  ...props
}: IconHomePlanCategoryProps) {
  const combinedClassName = cx(styles[category], className);
  switch (category) {
    case "contract": {
      return (
        <SvgIcon
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          className={combinedClassName}
        >
          <path d="M0.5 0.5H8.5V11.5H0.5V0.5Z" stroke="currentColor" />
          <path d="M2 2.5H4" stroke="currentColor" />
          <path d="M2 5.5H7" stroke="currentColor" />
          <path d="M2 7.5H5" stroke="currentColor" />
          <path d="M11.4995 2L11.4995 12" stroke="currentColor" />
          <path
            d="M11 1.5L11.4124 0.55726C11.4277 0.522476 11.462 0.5 11.5 0.5C11.538 0.5 11.5723 0.522476 11.5876 0.55726L12 1.5L11 1.5Z"
            fill="currentColor"
          />
        </SvgIcon>
      );
    }
    case "prospect": {
      return <IconPerson {...props} className={combinedClassName} />;
    }
    case "testing": {
      return (
        <SvgIcon
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          className={combinedClassName}
        >
          <path
            d="M10.6384 11.5H1.36159C0.977679 11.5 0.736995 11.0853 0.927468 10.7519L4.5 4.5V0.5H7.5V4.5L11.0725 10.7519C11.263 11.0853 11.0223 11.5 10.6384 11.5Z"
            stroke="currentColor"
          />
          <path d="M2.5 8.00011C5 7.00009 7 9.00009 9.5 8.00011" stroke="currentColor" />
          <path d="M3 0.5H9" stroke="currentColor" />
        </SvgIcon>
      );
    }
    case "closed": {
      return <IconLocked {...props} size={12} className={combinedClassName} />;
    }
    default: {
      return (
        <SvgIcon
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          className={combinedClassName}
        >
          <path d="M0.5 0.5H8.5V11.5H0.5V0.5Z" stroke="currentColor" />
          <path d="M2 2.5H4" stroke="currentColor" />
          <path d="M2 5.5H7" stroke="currentColor" />
          <path d="M2 7.5H5" stroke="currentColor" />
          <path d="M11.4995 2L11.4995 12" stroke="currentColor" />
          <path
            d="M11 1.5L11.4124 0.55726C11.4277 0.522476 11.462 0.5 11.5 0.5C11.538 0.5 11.5723 0.522476 11.5876 0.55726L12 1.5L11 1.5Z"
            fill="currentColor"
          />
        </SvgIcon>
      );
    }
  }
}
